import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Logo from '../../Resources/Icons/logo_main.svg';

export default function Header() {
  const [menuBtn, setMenuBtn] = useState();
  const [menu, setMenu] = useState();

  useEffect(() => {
    setMenuBtn(document.querySelector('.header__menu-btn'));
    setMenu(document.querySelector('.header__menu'));
  }, []);

  const onMenu = () => {
    menuBtn.classList.toggle('active');
    menu.classList.toggle('active');
  };

  return (
    <header className='header'>
      <div className='header__container-link'>
        <img src={Logo} className='header__logo' alt='Логотип' />
        <div className='header__title-container'>
          <p className='header__title'>Титов Андрей</p>
          <p className='header__subtitle'>разработчик, менеджер проектов</p>
        </div>
      </div>
      <div className='header__container-link'>
        <Link to='/' className='header__link'>
          Главная
        </Link>
        {/* <Link to='/services' className='header__link'>
          Услуги
        </Link> */}
        <Link to='/myWay' className='header__link'>
          Мой путь
        </Link>
        <Link to='/developments' className='header__link'>
          Разработки
        </Link>
        <div className='header__menu-btn' onClick={onMenu}>
          <span className='header__menu-span'></span>
          <span className='header__menu-span'></span>
          <span className='header__menu-span'></span>
        </div>
        <div className='header__menu'>
          <nav>
            <ul className='header__link-menu-container'>
              <li className='header__menu-li'>
                <Link to='/' className='header__link-menu' onClick={onMenu}>
                  Главная
                </Link>
              </li>
              {/* <li className='header__menu-li'>
                <Link
                  to='/services'
                  className='header__link-menu'
                  onClick={onMenu}
                >
                  Услуги
                </Link>
              </li> */}
              <li className='header__menu-li'>
                <Link
                  to='/myWay'
                  className='header__link-menu'
                  onClick={onMenu}
                >
                  Мой путь
                </Link>
              </li>
              <li className='header__menu-li'>
                <Link
                  to='/developments'
                  className='header__link-menu'
                  onClick={onMenu}
                >
                  Разработки
                </Link>
              </li>
            </ul>
          </nav>
        </div>
      </div>
    </header>
  );
}
